import React, { useState } from "react";
import styles from "../../styles/Docs/Docs.module.css";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Input } from "../inputs/Input";
import { Btn } from "../../styles/Button.styled";
import { DotsLoader } from "../Loaders/Loader";
import { updateAccount } from "../../actions/account";

type SaveStatus = "idle" | "saving" | "error";

function FieldRow({ label, value, last = false }: { label: string; value: string; last?: boolean }) {
  return (
    <div style={last ? { ...fieldRowStyle, borderBottom: "none" } : fieldRowStyle}>
      <span style={fieldLabelStyle}>{label}</span>
      <span style={fieldValueStyle}>{value || "—"}</span>
    </div>
  );
}

const cardStyle: React.CSSProperties = {
  backgroundColor: "var(--white)",
  padding: "20px",
  borderRadius: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

const fieldRowStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 0",
  borderBottom: "1px solid var(--border-blue-gray)",
};

const fieldLabelStyle: React.CSSProperties = {
  fontWeight: 700,
  fontSize: 14,
  color: "var(--dark)",
  minWidth: 120,
};

const fieldValueStyle: React.CSSProperties = {
  fontSize: 14,
  color: "var(--dark)",
  textAlign: "right",
};

export default function AccountSettings() {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);


  // null = view mode; string = edit mode with current draft value
  const [editEmail, setEditEmail] = useState<string | null>(null);
  const [saveStatus, setSaveStatus] = useState<SaveStatus>("idle");
console.log(user)
  const isEditing = editEmail !== null;

  const startEditing = () => {
    setEditEmail(user.email || "");
    setSaveStatus("idle");
  };

  const cancelEditing = () => {
    setEditEmail(null);
    setSaveStatus("idle");
  };

  const handleSave = async () => {
    if (editEmail === null) return;
    setSaveStatus("saving");
    try {
      await (dispatch as any)(updateAccount({ email: editEmail }));
      setEditEmail(null);
    } catch {
      setSaveStatus("error");
    }
  };

  return (
    <section className={`${styles.wrapper} ${styles.settings}`}>
      {/* <div className={styles.bigLable}>Налаштування облікового запису</div> */}

      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div style={cardStyle}>
          <div className={styles.middleLable}>Загальні налаштування</div>

          {isEditing ? (
            <Input label="Email" value={editEmail} onChange={setEditEmail} />
          ) : (
            <FieldRow label="Email" value={user.email || ""} />
          )}

          <FieldRow label="Прізвище" value={user.lastname || ""} />
          <FieldRow label={"Ім'я"} value={user.firstname || ""} />
          <FieldRow label="По батькові" value={user.middlename || ""} last />

          {isEditing ? (
            <>
              {saveStatus === "error" && (
                <div style={{ color: "var(--vivid-pink)", fontSize: 13 }}>Помилка збереження</div>
              )}
              <div style={{ display: "flex", gap: "12px" }}>
                <Btn
                  type="button"
                  $background="var(--orange)"
                  $color="var(--white)"
                  $width="140px"
                  $marginTop="0"
                  onClick={handleSave}
                  disabled={saveStatus === "saving"}
                >
                  {saveStatus === "saving" ? <DotsLoader scale={0.25} /> : "Зберегти"}
                </Btn>
                <Btn
                  type="button"
                  $background="transparent"
                  $color="var(--blue)"
                  $width="160px"
                  $marginTop="0"
                  onClick={cancelEditing}
                  style={{ border: "1px solid var(--blue)" }}
                >
                  Відхилити зміни
                </Btn>
              </div>
            </>
          ) : (
            <Btn
              type="button"
              $background="transparent"
              $color="var(--blue)"
              $width="140px"
              $marginTop="0"
              onClick={startEditing}
              style={{ border: "1px solid var(--blue)" }}
            >
              Редагувати
            </Btn>
          )}
        </div>
      </div>
    </section>
  );
}
